exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb8Kx{position:relative}._2wl4i{padding:20px;background:#fff}._2wl4i,.gmr70{text-align:center}.gmr70{background-color:#ffeb3b;border-bottom:1px solid #e0e0e0;text-decoration:none;width:40px;position:absolute;z-index:5;font-weight:700;text-transform:uppercase;font-size:11px}", ""]);

// exports
exports.locals = {
	"root": "mb8Kx",
	"default": "_2wl4i",
	"special": "gmr70"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/firms/components/FirmList/FirmList.css
// module id = 3057
// module chunks = 22